<div class="banner-wrapper">
  <img loading="lazy" [attr.data-src]="getTheaterImage()" [alt]="vars?.fundraiser?.story_title?.info_1" [default]="util.defaultImg" />
</div>
